// Pertes potentielles estimées par scénario : une barre par scénario, de la valeur basse (trait plein) à la valeur haute
// (plage claire). Une seule série, une seule teinte ; chaque barre porte son libellé et sa valeur en texte.
import type { Scenario } from '../api/types';
import { fourchette, eurosLong } from '../domaine/format';
import { lienVers } from '../routeur';

export function BarresPertes({ scenarios, nom }: { scenarios: Scenario[]; nom: (id: string) => string }) {
  const max = Math.max(1, ...scenarios.map((s) => s.perte.haut.valeur));
  return (
    <div className="barres" role="list" aria-label="Pertes potentielles estimées par scénario, de la valeur basse à la valeur haute">
      {scenarios.map((s) => {
        const bas = (s.perte.bas.valeur / max) * 100;
        const haut = (s.perte.haut.valeur / max) * 100;
        const libelle = `${s.nature === 'attaque' ? 'Attaque par' : 'Panne de'} ${nom(s.entree)}`;
        return (
          <a
            role="listitem"
            className="barre"
            key={s.id}
            href={lienVers('constats', { scenario: s.id })}
            title={`${libelle} : pertes potentielles estimées de ${eurosLong(s.perte.bas.valeur)} à ${eurosLong(s.perte.haut.valeur)}`}
          >
            <span>{libelle}</span>
            <span className="piste" aria-hidden="true">
              <span className="plage" style={{ left: 0, width: `${haut}%` }} />
              <span className="bas" style={{ width: `${Math.max(bas, 0.6)}%` }} />
            </span>
            <span className="valeur">{fourchette(s.perte.bas.valeur, s.perte.haut.valeur)}</span>
          </a>
        );
      })}
    </div>
  );
}
